import { useMutation } from '@tanstack/react-query';

import { validateBarberPasscodeMutation } from '@/api/booking/validateBarberPasscodeMutation';

import type { UseValidateBarberPasscodeMutationOptions } from './types';

export const useValidateBarberPasscodeMutation = (
  options?: UseValidateBarberPasscodeMutationOptions,
) => {
  return useMutation({
    ...validateBarberPasscodeMutation(),
    ...options,
  });
};
